<header>
    <h3>PROJECT DETAILS</h3>
    <nav>
        <core-helpers-navigation-three-dots-menu 
            *ngIf="accessUpload" 
            [menu]="menu"
            (action)="onMenuClick($event)"
        ></core-helpers-navigation-three-dots-menu>
    </nav>
</header>
<!-- DESCRIPTION -->
<article *ngIf="project.info != ''" class="project-details-description">
    <header>
        <h4>General Information</h4>
    </header>
    <div class="default-text" [innerHTML]="project.info">{{project.info}}</div>
</article>
<!-- ATTACHMENTS -->
<article class="project-details-attachments">
    <project-details-info-attachments 
        [showUpload]="showUpload"
        (uploadDone)="onUploadDone($event)"
    ></project-details-info-attachments>
</article>